"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOffersUnderReviewDataDto = instanceOfOffersUnderReviewDataDto;
exports.OffersUnderReviewDataDtoFromJSON = OffersUnderReviewDataDtoFromJSON;
exports.OffersUnderReviewDataDtoFromJSONTyped = OffersUnderReviewDataDtoFromJSONTyped;
exports.OffersUnderReviewDataDtoToJSON = OffersUnderReviewDataDtoToJSON;
exports.OffersUnderReviewDataDtoToJSONTyped = OffersUnderReviewDataDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var OfferUnderReviewDto_1 = require("./OfferUnderReviewDto");
/**
 * Check if a given object implements the OffersUnderReviewDataDto interface.
 */
function instanceOfOffersUnderReviewDataDto(value) {
    if (!('offers' in value) || value['offers'] === undefined)
        return false;
    return true;
}
function OffersUnderReviewDataDtoFromJSON(json) {
    return OffersUnderReviewDataDtoFromJSONTyped(json, false);
}
function OffersUnderReviewDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offers': (json['offers'].map(OfferUnderReviewDto_1.OfferUnderReviewDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function OffersUnderReviewDataDtoToJSON(json) {
    return OffersUnderReviewDataDtoToJSONTyped(json, false);
}
function OffersUnderReviewDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offers': (value['offers'].map(OfferUnderReviewDto_1.OfferUnderReviewDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
